import styled from 'styled-components';
import TextInputImplementation from './implementation/TextInputImplementation';
var TextInputComponent = styled(TextInputImplementation)(function (props) {
    var styleObject = props.theme.coreThemes.textInput.getStyleObjectBuilder(props, 'font', 'margin', 'padding', 'border', 'backgroundColor', 'width', 'height')
        .withBaseStyle({
        display: 'flex',
        flex: 1
    })
        .withWebStyle({
        boxSizing: 'border-box'
    })
        .withCustomStyle(props.customStyle)
        .build();
    return styleObject;
});
export default TextInputComponent;
//# sourceMappingURL=TextInputComponent.js.map